import React from 'react';
import { sizes } from 'src/styles/Media.styled';
import ItemsToBeBilledDesktop from './itemsToBeBilled/ItemsToBeBilled';
import NonBilledItemsDesktop from './nonBilledItems/AccountOwnedItems';
import ItemsToBeBilledMobile from './itemsToBeBilled/ItemsToBeBilledMobile';
import NonBilledItemsMobile from './nonBilledItems/AccountOwnedItemsMobile';
import Replenishment from './replenishment/Replenishment';
import DiscrepancyMobile from './discrepancy/DiscrepancyMobile';
import DiscrepancyDesktop from './discrepancy/Discrepancy';
import { noPriceErrorMsg } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { ErrorMsgContainer } from 'src/pages/reportUsage/record/components/itemsList/LotSerialQtyInput';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import { useSelector } from 'react-redux';

const ReviewItemsContainer = ({
    usageDetails,
    discrepencyUpdatedDetails,
    navigateToSpecifiedScreen,
    billedItems,
    setBilledItems,
    accountOwnedItems,
    priceOverrideReason,
    signatureDetails,
    replenGridData,
    totalBilledItemsPrice,
    billedNonTissueItemsQty,
    billedTissueItemsQty,
    emailInputBoxes,
    setEmailInputBoxes,
    isReportPayment,
    reportPaymentGridData,
    poTitle,
    handlePOTitle,
    handleSumTotal,
    displayPrice,
}) => {
    const replenishmentPageVisibilityUsage = useSelector(
        (state) => state.loginReducer.replenishmentPageVisibilityUsage
    );
    const bundleExpandCollapseIconClickHandler = (e, item, itemIdx) => {
        const modifiedData = [...billedItems];
        if (
            (item.isBundleItem || item.isBundleHeader) &&
            item.bundleItem?.length > 0 &&
            itemIdx >= 0
        ) {
            modifiedData[itemIdx].isBundleExpanded = modifiedData[itemIdx]
                .isBundleExpanded
                ? !modifiedData[itemIdx].isBundleExpanded
                : true;
            setBilledItems(modifiedData);
        }
    };

    return (
        <>
            {((billedItems?.length > 0 &&
                billedItems.some((item) => item.isPriceNotAvailable)) ||
                (accountOwnedItems?.length > 0 &&
                    accountOwnedItems.some(
                        (item) => item.isPriceNotAvailable
                    ))) && (
                <ErrorMsgContainer padding={'15px 0 5px'}>
                    <AlertMsg message={noPriceErrorMsg} />
                </ErrorMsgContainer>
            )}
            {window.innerWidth >= sizes.smalDevice ? (
                <>
                    <ItemsToBeBilledDesktop
                        navigateToSpecifiedScreen={navigateToSpecifiedScreen}
                        billedItems={billedItems}
                        priceOverrideReason={priceOverrideReason}
                        signatureDetails={signatureDetails}
                        totalBilledItemsPrice={totalBilledItemsPrice}
                        billedNonTissueItemsQty={billedNonTissueItemsQty}
                        billedTissueItemsQty={billedTissueItemsQty}
                        bundleExpandCollapseIconClickHandler={
                            bundleExpandCollapseIconClickHandler
                        }
                        poTitle={poTitle}
                        handlePOTitle={handlePOTitle}
                        handleSumTotal={handleSumTotal}
                        displayPrice={displayPrice}
                    />
                    {!isReportPayment && (
                        <NonBilledItemsDesktop
                            navigateToSpecifiedScreen={
                                navigateToSpecifiedScreen
                            }
                            accountOwnedItems={accountOwnedItems}
                        />
                    )}
                </>
            ) : (
                <>
                    <ItemsToBeBilledMobile
                        navigateToSpecifiedScreen={navigateToSpecifiedScreen}
                        billedItems={billedItems}
                        priceOverrideReason={priceOverrideReason}
                        signatureDetails={signatureDetails}
                        totalBilledItemsPrice={totalBilledItemsPrice}
                        billedNonTissueItemsQty={billedNonTissueItemsQty}
                        billedTissueItemsQty={billedTissueItemsQty}
                        bundleExpandCollapseIconClickHandler={
                            bundleExpandCollapseIconClickHandler
                        }
                        poTitle={poTitle}
                        handlePOTitle={handlePOTitle}
                        handleSumTotal={handleSumTotal}
                        displayPrice={displayPrice}
                    />
                    {!isReportPayment && (
                        <NonBilledItemsMobile
                            navigateToSpecifiedScreen={
                                navigateToSpecifiedScreen
                            }
                            accountOwnedItems={accountOwnedItems}
                        />
                    )}
                </>
            )}
            {replenishmentPageVisibilityUsage && (isReportPayment
                ? reportPaymentGridData.some(
                      (data) =>
                          data.isAdditionalCartEntry &&
                          data.isReplenishmentRequired &&
                          data.salesOrg !== 'S030' &&
                          !data?.cfn?.startsWith('B33') &&
                          data.materialType !== 'DIEN' &&
                          (data?.isBundleItem
                              ? data?.bundleItem &&
                                data?.bundleItem.length > 0 &&
                                !data?.bundleItem.every((child) =>
                                    child?.cfn?.startsWith('B33')
                                )
                              : true)
                  )
                : !(
                      usageDetails.unidId &&
                      !replenGridData?.some(
                          (replenItem) =>
                              replenItem.shippingDetails &&
                              Object.keys(replenItem.shippingDetails).length > 0
                      )
                  )) && (
                <Replenishment
                    navigateToSpecifiedScreen={navigateToSpecifiedScreen}
                    replenGridData={replenGridData}
                />
            )}
            {discrepencyUpdatedDetails?.discrepancyDto?.discrepancyEntries
                .length > 0 &&
                (window.innerWidth <= sizes.mobileDevice ? (
                    <>
                        <DiscrepancyMobile
                            usageDetails={usageDetails}
                            discrepencyUpdatedDetails={
                                discrepencyUpdatedDetails
                            }
                            emailInputBoxes={emailInputBoxes}
                            setEmailInputBoxes={setEmailInputBoxes}
                        />
                    </>
                ) : (
                    <>
                        <DiscrepancyDesktop
                            usageDetails={usageDetails}
                            discrepencyUpdatedDetails={
                                discrepencyUpdatedDetails
                            }
                            emailInputBoxes={emailInputBoxes}
                            setEmailInputBoxes={setEmailInputBoxes}
                        />
                    </>
                ))}
        </>
    );
};

export default ReviewItemsContainer;
